<div class="statistics" data-test-id="statistics-component">
  <div class="statistics__chart-view">
    <app-statistics-filter></app-statistics-filter>
    @if ((currentGraph$ | async) === 'yearly') {
      <app-yearly-graph [triggerRedraw]="redraw$ | async"></app-yearly-graph>
    } @else {
      <app-weekly-graph [triggerRedraw]="redraw$ | async"></app-weekly-graph>
    }
  </div>
</div>
